import AutoNumeric from "autonumeric";
import {NotificationToast} from "functions/NotificationToast";

let autoNumericOptionsFcfa = {
    digitGroupSeparator: ' ',
    decimalCharacter: '.',
    decimalCharacterAlternative: '.',
    currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.suffix,
    roundingMethod: AutoNumeric.options.roundingMethod.halfUpSymmetric,
    negativePositiveSignPlacement: 'p',
    minimumValue: 0,
    maximumValue: 2147483647,
    allowDecimalPadding: false,
    decimalPlaces: 0,
    modifyValueOnWheel: false,
    showWarnings: false
}

export class InputNumeric extends HTMLInputElement {

    connectedCallback() {
        this.type = "text"
        try {

            let max = this.dataset.max
            let min = this.dataset.min
            let decimal = this.dataset.decimal
            let suffix = this.dataset.suffix
            let negatif = this.dataset.negatif

            if (decimal !== undefined && parseFloat(decimal) > 0) {
                autoNumericOptionsFcfa.decimalPlaces = decimal;
                autoNumericOptionsFcfa.allowDecimalPadding = false;
            }

            if (negatif !== undefined && negatif === "true") {
                autoNumericOptionsFcfa.minimumValue = "-2147483647";
            }

            this.input = new AutoNumeric(this, autoNumericOptionsFcfa);

            if (max !== undefined) {
                if (parseFloat(max) > 2147483647) {
                    max = 2147483647
                }
                this.input.options.maximumValue(max)
            }

            if (min !== undefined) {
                this.input.options.minimumValue(min)
            }
            if (suffix !== undefined) {
                this.input.options.suffixText(suffix)
            }

        } catch (e) {
            if (!(e instanceof Error)) {
                e = new Error(e);
            }
            NotificationToast("error", e.message)

        }
    }

    disconnectedCallback() {
        this.input.remove()
        this.input = null
    }
}


export function InputNumericFromDom(element, value) {
    return new AutoNumeric(element, value, autoNumericOptionsFcfa)
}

